/* eslint-disable no-unused-vars */
import React, { FC, memo } from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import {
  warrantyTextStyles,
  warrantyViewStyles
} from 'src/views/transactions/TransactionPDF/styles';
import { RenderCurrency } from 'src/views/transactions/TransactionPDF/components';
import { RenderQuotationScreenShotCurrency } from './RenderQuotationScreenShotCurrency';

const styles = StyleSheet.create({
  root: {
    borderWidth: 1
  },
  pageNoContainer: {
    flex: 1,
    height: 21,
    justifyContent: 'center'
  },
  totalContainer: {
    flex: 1,
    borderBottomWidth: 0.3,
    borderTopWidth: 0.3,
    height: 21,
    justifyContent: 'center',
    backgroundColor: '#F4F4F4'
  }
});

interface Props {
  pageIndex?: number;
  pageSize?: number;
  totalAmount?: number;
}

const component: FC<Props> = ({ pageIndex, pageSize, totalAmount }) => {
  return (
    <View>
      <View style={warrantyViewStyles.row}>
        <View style={styles.pageNoContainer} />
        <View style={styles.totalContainer}>
          <View
            style={[
              warrantyViewStyles.row,
              { justifyContent: 'space-between' }
            ]}
          >
            <Text
              style={[
                warrantyTextStyles.openSansBold,
                { paddingLeft: 10, paddingTop: 2, color: '#2B3445' }
              ]}
            >{`GRAND TOTAL: `}</Text>
            <RenderQuotationScreenShotCurrency
              currencyImgStyle={{ height: 9, width: 9, marginTop: 2 }}
              textStyle={{ ...warrantyTextStyles.openSansBold, fontSize: 9.3 }}
              containerStyle={{ paddingRight: 4.5 }}
              amount={totalAmount || 0}
            />
          </View>
        </View>
      </View>
      <View
        style={{
          marginTop: 20,
          justifyContent: 'center'
        }}
      >
        <Text
          style={[
            warrantyTextStyles.openSansSemiBold,
            { fontSize: 5.5, textAlign: 'justify', color: '#FF0000' }
          ]}
        >
          BEWARE OF SCAMMERS!!! ONLY TRANSACT THROUGH OUR OFFICIAL FACEBOOK PAGE
          AND LEGITIMATE CONTACT NUMBERS PROVIDED ABOVE
        </Text>
        <Text
          style={[
            warrantyTextStyles.openSansSemiBold,
            { marginTop: 5, fontSize: 3.7, textAlign: 'justify' }
          ]}
        >
          THIS QUOTATION IS PROVIDED AS A NON-BINDING ESTIMATE BASED ON CURRENT
          INFORMATION. IT IS NOT AN INVOICE OR CONTRACT. FINAL PRICING IS
          SUBJECT TO CHANGE BASED ON AVAILABILITY, SPECIFICATIONS, OR ADDITIONAL
          REQUIREMENTS. FULL OR DOWN PAYMENT IS MAY BE REQUIRED PRIOR TO THE
          DELIVERY OF GOODS AND SERVICES.
        </Text>
      </View>
    </View>
  );
};

export const ViewQuotationSlipFooter = memo(component);
